import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { taskFormsApi, webFormsApi } from '../axios';
import { resumeApi } from '../axios/resume';
import { TaskForm } from '../types';

export function useAllFormsQuery(includeDeleted?: boolean) {
  return useQuery({
    queryKey: ['forms', `include-deleted-${includeDeleted}`],
    queryFn: () => taskFormsApi.getAllTaskForms(undefined, undefined, includeDeleted),
  });
}

export function useFormsForTaskAssignFilterQuery() {
  return useQuery({
    queryKey: ['forms-for-task-assign-filter'],
    queryFn: () => taskFormsApi.getFormsForTaskAssignFilter(),
  });
}

export function useFormQuestionsQuery(formId: TaskForm['id'], token?: string) {
  return useQuery({
    queryKey: ['questions', formId],
    queryFn: async () => {
      const form = await webFormsApi.getForm(formId.toString(), token);
      return form;
    },
    select: (data) => data.questions,
    enabled: !!formId,
  });
}

export function useFormsInfiniteQuery(searchQuery: string) {
  return useInfiniteQuery({
    queryKey: ['forms', searchQuery],
    queryFn: ({ pageParam = 1 }) => resumeApi.getTaskFormsWithSearch(pageParam, searchQuery),
    getNextPageParam: (lastPage) => {
      if (lastPage.page < lastPage.pages) {
        return lastPage.page + 1;
      }
      return undefined;
    },
    getPreviousPageParam: (firstPage) => {
      if (firstPage.page > 1) {
        return firstPage.page - 1;
      }
      return undefined;
    },
    initialPageParam: 1,
  });
}

export function useFormQuery(formId: TaskForm['id']) {
  return useQuery({
    queryKey: ['form', formId],
    queryFn: () => resumeApi.getTaskForm(formId),
    select: (data) => data.form,
    enabled: !!formId,
  });
}

export function useTaskFormFoldersQuery() {
  return useQuery({
    queryKey: ['taskFormFolders'],
    queryFn: () => taskFormsApi.getTaskFormsFolders(),
  });
}
